import { procurementAPI } from "../../axios";

export const actions = {

    //Rfq
    GetSingleRfq(context, data){
        return procurementAPI.get(`Rfq/${data}`);
    },
    GetRFQCarts(context, data){
        return procurementAPI.get(`Rfq/Draft/${data.cycle}/${data.campusId}`);
    },
    // GetReturnedRfq(context, data){
    //     return procurementAPI.get(`Rfq/posted/${data.cycle}/${data.campusId}`);
    // },
    GetSubmittedRfq(context, data){
        return procurementAPI.get(`Rfq/Submitted/${data.cycle}/${data.campusId}`);
    },
    GetPostedRfq(context, data){
        return procurementAPI.get(`Rfq/Posted/${data.cycle}/${data.campusId}`);
    },
    GetApprovedRfq(context, data){
        return procurementAPI.get(`Rfq/approved/${data}`);
    },
    UpdateRfq(context, data){
        return procurementAPI.put(`Rfq/${data.id}`, data);
    },
    DeleteRfq(context, data){
        return procurementAPI.delete(`Rfq/${data}`);
    },
    CreateRfq(context, data){
        return procurementAPI.post(`Rfq/CreateRfq`, data);
    },
    SubmitRfq(context, data){
        return procurementAPI.put(`Rfq/Submit/${data.id}`, data);
    },
    PostRfq(context, data){
        return procurementAPI.put(`Rfq/post/${data}`);
    },
    ApproveRfq(context, data){
        return procurementAPI.put(`Rfq/approve/${data}`);
    },
    ReturnRfq(context, data){
        return procurementAPI.put(`Rfq/return/${data.id}?remarks=${data.remarks}`);
    },
    AvailableSuppliers(context, data){
        return procurementAPI.get(`Rfq/Available/Supplier/${data}`);
    },
    RecanvasItems(context, data){
        return procurementAPI.post(`Rfq/Create/ReCanvas`, data);
    },
    GetRecanvasItems(context, data){
        return procurementAPI.get(`Rfq/Recanvas/${data.cycle}/${data.campusId}`);
    },
    RegenerateRfqNumber(context, data){
        return procurementAPI.get(`Rfq/GetRfqNumber/${data}`);
    },
    GetWavedItems(context, data){
        return procurementAPI.get(`Rfq/Waved/${data.campusId}/${data.cycle}`);
    },
    ReAwardItem(context, data){
        return procurementAPI.put(`Rfq/Reawarded/${data}`);
    },
    ReAwardWavedItems(context, data){
        return procurementAPI.post(`Rfq/ReAward/WavedItems`, data);
    },
    UpdateRFQNo(context, data){
        return procurementAPI.put(`Rfq/Update/RfqNumber/${data.id}`, data);
    }
}